/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Expectlist_Charactersstrong2Inputs */

const id_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Karakter yang Dapat Dimainkan`)
};

const ms_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Watak Boleh Dimainkan`)
};

const da_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Spilbare Figurer`)
};

const de_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ spielbare Charaktere`)
};

const en_us2_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Playable Characters`)
};

const es_es2_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 300 personajes jugables`)
};

const es_mx2_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 300 personajes jugables`)
};

const fil_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Character na Maaaring Laruin`)
};

const fr_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ personnages jouables`)
};

const it_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre 300 personaggi giocabili`)
};

const hu_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ játszható karakter`)
};

const nl_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ speelbare personages`)
};

const no_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ spillbare karakterer`)
};

const pl_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponad 300 grywalnych postaci`)
};

const pt_br2_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 300 personagens jogáveis`)
};

const pt_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 300 personagens jogáveis`)
};

const ro_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peste 300 de personaje jucabile`)
};

const fi_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yli 300 pelattavaa hahmoa`)
};

const sv_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Över 300 spelbara karaktärer`)
};

const vi_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hơn 300 nhân vật có thể chơi`)
};

const tr_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ Oynanabilir Karakter`)
};

const cs_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ hratelných postav`)
};

const bg_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ играеми героя`)
};

const ru_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ игровых персонажей`)
};

const uk_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ ігрових персонажів`)
};

const ar_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكثر من 300 شخصية قابلة للعب`)
};

const hi_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ पात्र`)
};

const th_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตัวละครที่เล่นได้มากกว่า 300 ตัว`)
};

const ja_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300以上のプレイアブルキャラクター`)
};

const zh_cn2_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ 可控角色`)
};

const zh_hant1_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300+ 可控角色`)
};

const ko_misc_posts_expectlist_charactersstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Charactersstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300개 이상의 플레이 가능 캐릭터`)
};

/**
* | output |
* | --- |
* | "300+ Playable Characters" |
*
* @param {Misc_Posts_Expectlist_Charactersstrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_charactersstrong2 = /** @type {((inputs?: Misc_Posts_Expectlist_Charactersstrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Charactersstrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "da") return da_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "de") return de_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "it") return it_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "no") return no_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "th") return th_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_charactersstrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_charactersstrong2(inputs)
	return ko_misc_posts_expectlist_charactersstrong2(inputs)
});
export { misc_posts_expectlist_charactersstrong2 as "misc.posts.expectList.charactersStrong" }